import { connect } from 'react-redux';
import React, { Component } from 'react';
import { withRouter } from 'react-router';

import { LoadingBase } from 'Components/';
import { Main, Filter } from 'Containers/';
import { errorToast } from 'Common/ToastHelper';
import { UNIVERSAL_DATA_EXPORT_FORM_NAME } from 'Common/FormEnum';
import * as UniversalDataExportActions from 'Pages/universaldataexport/state/actions';
import * as UniversalDataExportSelectors from 'Pages/universaldataexport/state/selectors';
import { UniversalDataExportEnum as Fields } from 'Common/FieldEnum';
import * as UDEConstants from 'Pages/universaldataexport/helpers/constants';

import { UniversalDataExportForm } from './components/UniversalDataExportForm';

import 'Styles/pages/universaldataexport/index.less';

class UniversalDataExport extends Component {
  initialValues = {
    [Fields.ConfigId]: 0,
    [Fields.GroupId]: UDEConstants.DEFAULT_GROUP_ID,
    [Fields.SelectedFieldIds]: [],
    [Fields.SelectedSites]: [],
    [Fields.ExportType]: UDEConstants.DEFAULT_EXPORT_TYPE,
    [Fields.Status]: 0,
  };

  componentDidMount() {
    const { getPage } = this.props;
    getPage();
  }

  componentDidUpdate(prevProps) {
    const { clearErrors } = this.props;
    errorToast(this.props, prevProps, 'fetchError', clearErrors);
  }

  getMainProps = () => {
    return {
      toolbox: {
        formName: UNIVERSAL_DATA_EXPORT_FORM_NAME,
        shown: true,
        backButtonProps: {
          shown: false,
        },
        saveButtonProps: {
          content: 'Export',
        },
      },
      shouldNotUsePageWidth: true,
    };
  };

  handleOnSubmit = data => {
    const { exportData } = this.props;
    exportData(data);
  };

  render() {
    const {
      isFetching,
      fetchError,
      groupOptions,
      fields,
      fieldsByGroupId,
      formValues,
      configsMap,
      configOptions,
      getPage,
      exportData,
      clearErrors,
    } = this.props;
    const { handleOnSubmit, initialValues } = this;

    return (
      <div className="universal-data-access-container">
        {isFetching && <LoadingBase />}
        <Filter title="Universal Data Export" />
        <Main {...this.getMainProps()}>
          <UniversalDataExportForm
            initialValues={initialValues}
            onSubmit={handleOnSubmit}
            fetchError={fetchError}
            groupOptions={groupOptions}
            fields={fields}
            fieldsByGroupId={fieldsByGroupId}
            formValues={formValues}
            configsMap={configsMap}
            configOptions={configOptions}
            getPage={getPage}
            exportData={exportData}
            clearErrors={clearErrors}
          />
        </Main>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isFetching: UniversalDataExportSelectors.getFetching(state),
  fetchError: UniversalDataExportSelectors.getFetchError(state),
  groupOptions: UniversalDataExportSelectors.getGroupOptions(state),
  fieldsByGroupId: UniversalDataExportSelectors.getFieldsByGroupId(state),
  formValues: UniversalDataExportSelectors.getUniversalDataExportFormValues(
    state
  ),
  configsMap: UniversalDataExportSelectors.getConfigsMap(state),
  configOptions: UniversalDataExportSelectors.getConfigOptions(state),
  fields: UniversalDataExportSelectors.getFields(state),
});

const mapDispatchToProps = {
  getPage: UniversalDataExportActions.getPage,
  exportData: UniversalDataExportActions.exportData,
  clearErrors: UniversalDataExportActions.clearErrors,
};

UniversalDataExport = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(UniversalDataExport)
);

UniversalDataExport.path = '/universaldataexport';

export { UniversalDataExport };



// WEBPACK FOOTER //
// ./src/pages/universaldataexport/UniversalDataExport.js